import {
  addressUI,
  addressSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

const updatedAddressSchema = addressSchema({
  omit: ['street3', 'isMilitary'],
  extend: {
    street: { maxLength: 30 },
    street2: { maxLength: 5 },
    city: { maxLength: 18 },
  },
});

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-dependents-address-title']),
    custodianAddress: addressUI({
      labels: {
        street2: content['address-street-2'],
      },
      omit: ['isMilitary', 'street3'],
    }),
  },
  schema: {
    type: 'object',
    properties: {
      custodianAddress: updatedAddressSchema,
    },
    required: ['custodianAddress'],
  },
};
